import Close from 'shared/components/icons/close'
import TapLink from 'shared/components/tap-link'
import styled from 'styled-components'

const Container = styled(TapLink)`
    align-self: flex-start;
`
const BackButton = ({ className = '', onTapAction }) => (
    <Container className={className} onTap={onTapAction || (() => history.back())}>
        <Close />
    </Container>
)

export default BackButton
